import React, {Component} from 'react'

import Header from '../header'
import HeroSection from './heroOne'
import Footer from '../footer'
import Head from "next/head";

export default class Index extends Component{
    render(){
        return(
            <div>
                <Head>
                    <meta charSet="utf-8" />
                    <meta name="viewport" content="width=device-width,initial-scale=1.0" />

                    <title>Kehila.io | Retrouvez tous vos organismes sur une seule plateforme</title>
                    <link rel="icon" href={"/logo-white.png"}/>

                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css"
                          integrity="sha512-MV7K8+y+gLIBoVD59lQIYicR65iaqukzvf/nwasF0nqhPay5w/9lJmVM2hMDcnK1OnMGCdVK+iQrJ7lzPJQd1w=="
                          crossOrigin="anonymous" referrerpolicy="no-referrer"/>


                    <link href="/assets/css/bootstrap.min.css" rel="stylesheet"/>
                    <link href="/assets/css/style.css" rel="stylesheet"/>
                </Head>
                <div id="main" className="main-content-wraper">
                    {/* start inner content */}
                    <div className="main-content-inner">
                        <Header />
                        <HeroSection />
                        <Footer />
                    </div>
                </div>
            </div>
        )
    }
}
